import store from "@/store";
import { PRINT_METHOD_ALLOWED_EMAILS } from "@/helpers/constants";
import Vue from "vue";

type PrintMethod = "old" | "new";

let printMethodResolve: ((value: PrintMethod) => void) | null = null;

export function getPrintMethod(vm: Vue): Promise<PrintMethod> {
  const user = store.getters["auth/getCurrentUser"];
  const userEmail: string = user?.email ?? "";
  const canSelectPrintMethod = PRINT_METHOD_ALLOWED_EMAILS.includes(userEmail);
  if (!canSelectPrintMethod) {
    return Promise.resolve("new");
  }
  return new Promise<PrintMethod>(resolve => {
    printMethodResolve = resolve;
    vm.$modal.show("printMethodModal");
  });
}

export function resolvePrintMethod(vm: Vue, method: PrintMethod): void {
  vm.$modal.hide("printMethodModal");
  if (printMethodResolve) {
    printMethodResolve(method);
    printMethodResolve = null;
  }
}
